import React, { useEffect, useState, useRef, useContext } from 'react';
import { useSelector } from 'react-redux';
import ModifierCard from './ModifierCard';
import { ReactSVG } from 'react-svg';
import CarauselComp from 'atoms/Carausel/Presentation/CarauselComp';
import { isEmptyObject, isMobileDevice, getTernaryValue, getAndCheck } from 'common/utilities/utils';
import PRODUCT_CONSTANTS from '../Constants/ProductListingModalOptionsConstants';
import { UserOrderContext } from 'context/context';
import {
  getUniqueSizes,
  setAnalyticsDataForUpsize,
} from '../ProductListingModalOptionsUtilities/ProductListingModalOptionsUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/Constants/MenuPDPPageConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const { HamburgerDownArrow, filter_options_stoke } = IMAGE_PATH;

/* check which size shold be selected upon dropdown */
export const checkSizeSelected = (selectedOption, mockModifiersList) => {
  return isEmptyObject(selectedOption)
    ? mockModifiersList.filter(mod => mod.size === selectedOption.name)
    : mockModifiersList;
};

const getCartModifiers = (modgrpId, userOrderState, userOrderStateDispatch, cartData) => {
  const { FROMFLAGEDIT } = START_ORDER_CONSTANTS;
  const { MODGROUP_IDS_UPDATE } = MENU_PDP_PAGE_CONSTANTS;
  if (userOrderState?.minipdpData?.fromFlag === FROMFLAGEDIT) {
    let itemMatched = cartData.foodLines.find(({ id }) => id === userOrderState.minipdpData.foodLineId);
    let modGroupMatched = itemMatched?.item?.modGrps?.find(({ id }) => id === modgrpId);
    if (modGroupMatched) {
      let upsizedModifier = modGroupMatched.modifiers.filter(({ isDefault }) => !isDefault).length;
      if (upsizedModifier && !userOrderState?.pdpScreenCommons?.modGroupIdsUpdated.includes(modGroupMatched.id)) {
        userOrderStateDispatch({ type: MODGROUP_IDS_UPDATE, value: modGroupMatched.id });
      }
      return modGroupMatched.modifiers;
    } else {
      return {};
    }
  } else {
    return {};
  }
};

const getRateText = (itemName, REGULAR) => {
  if (itemName !== REGULAR) {
    return <span>{':'}</span>;
  }
};

const getSelectedRate = (selectedOption, REGULAR, currencySymbol) => {
  if (selectedOption.rate) {
    if (selectedOption.name !== REGULAR) {
      return `+${currencySymbol}${selectedOption.rate}`;
    } else {
      return '';
    }
  } else {
    return '';
  }
};

const getUpsizeLength = (modifiersData, savedModifiers, currencyConversionFactor, showPriceWithTax) => {
  return (
    modifiersData &&
    modifiersData.length &&
    getUniqueSizes(modifiersData, savedModifiers, currencyConversionFactor, showPriceWithTax).length > 0
  );
};

const setSelectedValueForFilter = (setSelectedOption, itemVar, modifiersData) => {
  if (isEmptyObject(itemVar)) {
    setSelectedOption(itemVar);
    return modifiersData.filter(mod => mod.size === itemVar.name);
  } else {
    return modifiersData;
  }
};

/**
 * ProductListingModalItems Component
 * @param {*} props - Object - title
 */
const ProductListingModalItems = props => {
  const { data: modifiersData, min, max, showSelectedModifier, modgrpId, modGrpName } = props;
  const { REGULAR = '', UPLIFTPLACEHOLDER = '', SINGLE } = PRODUCT_CONSTANTS;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const [savedModifiers, setSavedModifiers] = useState([]);
  const [selectedOption, setSelectedOption] = useState({});
  const [filterOpen, setFilterOpen] = useState(false);
  const [updatedItems, setUpdatedItems] = useState([]);
  const [defaultSelected, setDefaultSelected] = useState(true);
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const [updatedModifiers, setUpdatedModifiers] = useState(modifiersData);
  const cartReducer = useSelector(data => data.cartReducer);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { currencySymbol, currencyConversionFactor, componentOptions } = tenantReducer;
  const { web: { global: { showPriceWithTax = false } = {} } = {} } = componentOptions ?? {};

  const [itemVar, setItemVar] = useState({});
  const [cartModifiers, setCartModifiers] = useState({});
  const ref = useRef(null);
  const desktopRef = useRef(null);
  const desktopListRef = useRef(null);
  const settings = {
    dots: false,
    infinite: true,
    speed: 200,
    slidesToShow: 2,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: false,
    arrows: false,
    focusOnSelect: true,
  };

  useEffect(() => {
    const mockModifiersList = getTernaryValue(modifiersData.length, JSON.parse(JSON.stringify(modifiersData)), []);
    let modifiers = checkSizeSelected(selectedOption, mockModifiersList);
    setUpdatedModifiers([...modifiers]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modifiersData]);

  const savedModifierHandler = (cardData, flag, savedModifiersData) => {
    let { id } = cardData;
    if (flag === SINGLE) {
      modifiersData.forEach(item => {
        if (item.id === id) {
          setUpdatedItems([item.id]);
        }
      });
      setSavedModifiers([{ ...cardData, itemId: id, modgrpId }]);
    } else if (flag) {
      let exists = savedModifiersData.some(({ id: modifierId }) => modifierId === cardData.id);
      !exists && setSavedModifiers([...savedModifiersData, { ...cardData, itemId: id, modgrpId }]);
    } else if (savedModifiersData.length) {
      let modifiers = savedModifiersData.filter(({ itemId }) => itemId !== id);
      setSavedModifiers(modifiers);
    }
  };

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  useEffect(() => {
    let getCartModifiersData = getCartModifiers(
      modgrpId,
      userOrderState,
      userOrderStateDispatch,
      cartReducer?.cartData,
    );
    setCartModifiers(getCartModifiersData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    showSelectedModifier(savedModifiers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(savedModifiers)]);

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  useEffect(() => {
    if (filterOpen) {
      document.addEventListener('click', handleOutsideClick);
    } else {
      document.removeEventListener('click', handleOutsideClick);
    }
  }, [filterOpen]);

  const handleOutsideClick = e => {
    if (
      getAndCheck(ref.current, ref.current === e.target) ||
      (desktopRef.current &&
        desktopListRef.current &&
        desktopRef.current !== e.target &&
        !desktopListRef.current.contains(e.target))
    ) {
      setFilterOpen(false);
    }
  };

  const onDropDrownClick = () => {
    setFilterOpen(true);
  };

  const onDesktopDropDrownClick = () => {
    setFilterOpen(!filterOpen);
  };

  const selectHandler = (item, modgrp_name) => {
    setSelectedOption(item);
    let modifiers = modifiersData.filter(mod => mod.size === item.name);
    setUpdatedModifiers(modifiers);
    setAnalyticsDataForUpsize(modgrp_name);
    setFilterOpen(!filterOpen);
  };

  const selectItemMobile = item => {
    setFilterOpen(true);
    setItemVar(item);
    setDefaultSelected(false);
  };

  const selectHandlerMobile = (item_var, modgrp_name, defaultValue) => {
    let modifiers = setSelectedValueForFilter(setSelectedOption, item_var, modifiersData);
    setUpdatedModifiers(modifiers);
    setAnalyticsDataForUpsize(modgrp_name);
    setDefaultSelected(!defaultValue);
    setFilterOpen(false);
  };

  const setDefaultItem = () => {
    setSelectedOption({});
    setItemVar({});
    setDefaultSelected(true);
  };

  const getColon = () => {
    let colonStr = '';
    let selectedRate = getSelectedRate(selectedOption, REGULAR, currencySymbol);
    colonStr = getTernaryValue(selectedRate.length > 0, ':', '');
    return colonStr;
  };

  const desktopItemList = () => {
    return (
      <React.Fragment>
        {getUpsizeLength(modifiersData, savedModifiers, currencyConversionFactor, showPriceWithTax) && (
          <div className='uplift-dropdown' data-testid='desktop-uplift-dropdown'>
            <div
              className='language-select-uplift'
              ref={desktopRef}
              data-testid='desktop-dropdown-filter'
              onClick={onDesktopDropDrownClick}
            >
              <span data-testid='uplift-order-text'>
                {getTernaryValue(
                  selectedOption.name,
                  selectedOption.name + getColon(),
                  translateWithI18Next(UPLIFTPLACEHOLDER),
                )}
              </span>
              <span className='selected-rate'>{getSelectedRate(selectedOption, REGULAR, currencySymbol)}</span>
              <img className='dropdown-img-ham' src={HamburgerDownArrow} alt='DropDowm' />
            </div>
            {filterOpen && (
              <div ref={desktopListRef}>
                <ul className='filter-list'>
                  {getUniqueSizes(modifiersData, savedModifiers, currencyConversionFactor, showPriceWithTax).map(item =>
                    getFilterListNames(item, selectHandler, modGrpName, REGULAR, currencySymbol, selectedOption),
                  )}
                </ul>
              </div>
            )}
          </div>
        )}
        <div className='modifier-list-items'>
          {updatedModifiers && updatedModifiers.length && cartModifiers
            ? updatedModifiers.map((item, ind) => {
                return (
                  <ModifierCard
                    key={ind}
                    min={min}
                    max={max}
                    cardData={item}
                    savedModifierHandler={savedModifierHandler}
                    savedModifiers={savedModifiers}
                    tenantReducer={tenantReducer}
                    modGrpName={modGrpName}
                    modgrpId={modgrpId}
                    updatedItems={updatedItems}
                    getCartModifiers={cartModifiers}
                  />
                );
              })
            : null}
        </div>
      </React.Fragment>
    );
  };

  const mobileItemList = () => {
    const getCaraousel = () => (
      <CarauselComp settings={settings}>
        {updatedModifiers && updatedModifiers.length && cartModifiers
          ? updatedModifiers.map((item, ind) => {
              return (
                <ModifierCard
                  key={ind}
                  cardType='carousal'
                  min={min}
                  max={max}
                  cardData={item}
                  savedModifierHandler={savedModifierHandler}
                  savedModifiers={savedModifiers}
                  tenantReducer={tenantReducer}
                  modgrpId={modgrpId}
                  modGrpName={modGrpName}
                  updatedItems={updatedItems}
                  getCartModifiers={cartModifiers}
                />
              );
            })
          : null}
      </CarauselComp>
    );
    return (
      <React.Fragment>
        {getUpsizeLength(modifiersData, savedModifiers, currencyConversionFactor, showPriceWithTax) && (
          <div className='uplift-dropdown' data-testid='mob-uplift-dropdown'>
            <div className='language-select-uplift' data-testid='mobile-dropdown-filter' onClick={onDropDrownClick}>
              <span data-testid='uplift-order-text'>
                {getTernaryValue(
                  selectedOption.name,
                  selectedOption.name + getColon(),
                  translateWithI18Next(UPLIFTPLACEHOLDER),
                )}
              </span>
              <span className='selected-rate'>{getSelectedRate(selectedOption, REGULAR, currencySymbol)}</span>
              <img className='dropdown-img-ham' src={HamburgerDownArrow} alt='DropDown' />
            </div>
          </div>
        )}

        {filterOpen && (
          <div className='mobile-modal-filter-background' ref={ref}>
            <div className='mobile-modal-filter'>
              <div className='mobile-modal-filter-container'>
                <ul className='mobile-filter-list'>
                  <li
                    className={
                      defaultSelected && Object.keys(selectedOption).length === 0
                        ? 'mobile-filter-list-items-selected'
                        : 'mobile-filter-list-items-default'
                    }
                    data-testid='mobile-click-default'
                    onClick={setDefaultItem}
                  >
                    <div className='mobile-rate-container'>{translateWithI18Next(UPLIFTPLACEHOLDER)}</div>
                  </li>
                  {getUniqueSizes(modifiersData, savedModifiers, currencyConversionFactor, showPriceWithTax).map(
                    item => (
                      <li
                        key={item.name}
                        className={
                          item.name === itemVar.name ? 'mobile-filter-list-items-selected' : 'mobile-filter-list-items'
                        }
                        data-testid={`item-${item.name}-click`}
                        onClick={() => selectItemMobile(item)}
                      >
                        <div className='mobile-rate-container'>
                          <span className='mobile-filter-item-name'>{item.name}</span>
                          {getRateText(item.name, REGULAR)}
                          <span className='mobile-filter-item-rate'>
                            {item.name !== REGULAR ? `+${currencySymbol}${item.rate.toFixed(2)}` : ''}
                          </span>
                        </div>
                      </li>
                    ),
                  )}
                </ul>
              </div>
              <div
                className='mobile-modal-filter-button'
                data-testid='mobile-filter-done'
                onClick={() => selectHandlerMobile(itemVar, modGrpName, itemVar.name === selectedOption.name)}
              >
                {translateWithI18Next('done')}
              </div>
            </div>
          </div>
        )}
        <div className={`modifier-list-items modifier-list-items-in`}>
          {updatedModifiers && updatedModifiers.length > 2 && cartModifiers
            ? getCaraousel()
            : (updatedModifiers &&
                updatedModifiers.length &&
                cartModifiers &&
                updatedModifiers.map((item, ind) => {
                  return (
                    <ModifierCard
                      key={ind}
                      cardType='regular'
                      min={min}
                      max={max}
                      cardData={item}
                      savedModifierHandler={savedModifierHandler}
                      savedModifiers={savedModifiers}
                      tenantReducer={tenantReducer}
                      modgrpId={modgrpId}
                      modGrpName={modGrpName}
                      updatedItems={updatedItems}
                      getCartModifiers={cartModifiers}
                    />
                  );
                })) ||
              null}
        </div>
      </React.Fragment>
    );
  };
  return getTernaryValue(isMobile, mobileItemList(), desktopItemList());
};

export default ProductListingModalItems;
function getFilterListNames(item, selectHandler, modGrpName, REGULAR, currencySymbol, selectedOption) {
  return (
    <li
      key={item.name}
      className='filter-list-items'
      data-testid={`item-${item.name}-click`}
      onClick={() => selectHandler(item, modGrpName)}
    >
      <span>{item.name}</span>
      <div className='rate-container'>
        <span className='filter-item-rate'>{item.name !== REGULAR ? `+${currencySymbol}${item.rate}` : ''}</span>
        {item.name === selectedOption.name && <ReactSVG src={filter_options_stoke} className='selected-stroke' />}
      </div>
    </li>
  );
}
